@if(stepCount() >= 2) {
  <div class="flex flex-row justify-center">
    @switch (theme()) {
      @case ("dark&white") {
        @for(_ of stepIterable(); let i = $index; track i) {
          <div class="h-2 rounded-full mx-1 transition-all" [ngClass]="{
            'w-2': activeStepIndex() !== i,
            'w-6': activeStepIndex() === i,
            'bg-[#FFFFFF]': activeStepIndex() !== i,
            'bg-[#2F2F2F]': activeStepIndex() === i,
          }"></div>
        }
      }
      @case ("dark&gray") {
        @for(_ of stepIterable(); let i = $index; track i) {
          <div class="h-2 rounded-full mx-1 transition-all" [ngClass]="{
            'w-2': activeStepIndex() !== i,
            'w-6': activeStepIndex() === i,
            'bg-[#A8A8A8]': activeStepIndex() !== i,
            'bg-[#2F2F2F]': activeStepIndex() === i,
          }"></div>
        }
      }
    }
  </div>
}
